import { appName } from '@/config';
import { ElLink } from '@qsxy/element-plus-react';

const Announcement = () => {
	return (
		<div className="ttn-announcement">
			<div className="content">
				<ElLink underline style={{ '--el-link-font-size': '16px' }}>
					{appName}现已集成最高性能版本 DeepSeek R1 推理模型。
				</ElLink>
			</div>

			{/* <ElLink>
				<ElIcon name="close" prefix="fas" />
			</ElLink> */}
		</div>
	);
};

export default Announcement;
